import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { objectKeysToSelectedCase } from '@shared/helpers';
import { isArray } from 'lodash';

/**
 * Nagłówek wyłączający konwersję nazw pól w odpowiedzi. Wystawiony jako stała, bo od
 * zadania B5.4 potrzebuje go też interceptor uwierzytelniania — a literał powtórzony
 * w kilku plikach rozjeżdża się przy pierwszej literówce, cicho i bez błędu.
 */
export const ignoreCamelCaseInterceptorHeaderData = {
  'ignore-camel-case-interceptor': '1',
};

@Injectable()
export class ConvertToCamelCase implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has('ignore-camel-case-interceptor')) {
      return next.handle(request);
    }
    return next.handle(request).pipe(map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse && !String(event.url).includes('token')) {
        return event.clone({
          body: objectKeysToSelectedCase(event.body, 'camel', isArray(event.body), true)
        });
      }

      return event;
    }));
  }
}
